import { React, useState, useEffect } from 'react';
import MasterPage from '../Templates/MasterPage';
import Footer from '../Templates/Footer';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { server } from '../server';
import { Company_Id, Corporate_Id, Vendor_Id,Corporate_Name,Vendor_Name } from "../Helper";

export default function Profile() {
    let userMobNo = localStorage.getItem('contactNo');

    const [getprofile, setProfile] = useState({
        name: localStorage.getItem("EmployeeName"),
        email: localStorage.getItem("emailId"),
        mobileNo: localStorage.getItem("contactNo"),
        WebUserPassword: localStorage.getItem("WebUserPassword"),
        password: ""
    });

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();
    const JWTToken = localStorage.getItem('Token');
    let EmpId = localStorage.getItem("userid");

    const localstorage1 = localStorage.getItem("userid");

    useEffect(() => {
        if (localstorage1 == null) {
            navigate('/');
        }
    }, [localstorage1]);

    const deleteProfile = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteUserData();
            }
        });
    };

    async function deleteUserData() {
        let result = await fetch(`${server}/api/Registration/deleteprofile`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            body: JSON.stringify({ MobileNo: userMobNo })
        });
        result = await result.json();

        if (result.statusCode === 200 && result.statusMessage === 'Account Deleted successfully') {
            Swal.fire('Deleted!', 'Your profile has been deleted.', 'success');
            navigate('/');
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: result.StatusMessage,
            });
        }
    }

    const changepass = () => setIsOpen(!isOpen);

    const updatepass = (event) => {
        event.preventDefault();

        if (newPassword.length < 8) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Password must be at least 8 characters long',
            });
            return;
        }

        if (newPassword !== confirmPassword) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Passwords do not match',
            });
            return;
        }

        // setProfile({ ...getprofile, password: newPassword });
        setProfile(prev => ({ ...prev, password: newPassword }));
        localStorage.setItem("NewUserPassword", newPassword);
        setIsOpen(false);

        updateProfiledetails(newPassword);
    };


 const updateProfiledetails = async (latestPassword = null) => {
    const finalPassword = latestPassword || getprofile.password || getprofile.WebUserPassword;

    if (!getprofile.name || !getprofile.email || !getprofile.mobileNo || getprofile.mobileNo.length < 10) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Please fill all the fields correctly',
        });
        return;
    }

    try {
        const response = await fetch(`${server}/api/Siemens/UpdateProfileInfo`, {
            method: "POST",
            headers: {
                Authorisation: `${JWTToken}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                CompanyId: Company_Id(),
                CorporateId: Corporate_Id(),
                EmpId: EmpId,
                VendorId: Vendor_Id(),
                Name: getprofile.name,
                Email: getprofile.email,
                UserPassword: finalPassword,
                MobileNo: getprofile.mobileNo,
                ConfirmPassword: finalPassword
            }),
        });

        const body = await response.json();

        if (body.data[0].Response === "Updated SuccessFully") {
            localStorage.setItem("WebUserPassword", finalPassword);

            Swal.fire({
                icon: 'success',
                title: 'Profile Updated Successfully',
                text: body.data[0].Response,
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: body.data[0].Response,
            });
        }

    } catch (error) {
        console.error("Error updating profile:", error);
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong. Please try again.",
        });
    }
};



    return (
        <>
            <MasterPage heading="Profile" />
            <div className="content-wrapper" style={{ minHeight: '100VH', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}>
                <div className="container my-5 d-flex justify-content-center">
                    <div className="profile-card bg-light p-5 rounded-4 shadow-sm"
                        style={{ maxWidth: '800px', width: '100%', border: '1px solid #ccc', backgroundColor: '#E5E5E5', borderRadius: '20px' }}
                    >
                        <h4 className="fw-semibold mb-4">Profile</h4>
                        <hr />

                        <form>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className="form-control bg-white"
                                        value={getprofile.name}
                                        onChange={(e) => setProfile({ ...getprofile, name: e.target.value })}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Email ID</label>
                                    <input
                                        readOnly
                                        type="email"
                                        className="form-control bg-white"
                                        value={getprofile.email}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Contact No</label>
                                    <input
                                        type="text"
                                        className="form-control bg-white"
                                        maxLength={10}
                                        inputMode="numeric"
                                        pattern="\d*"
                                        value={getprofile.mobileNo}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            if (value.length <= 10) {
                                                setProfile({ ...getprofile, mobileNo: value });
                                            }
                                        }}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Password</label>
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="form-control pe-5 bg-white"
                                            value={isOpen ? newPassword : getprofile.WebUserPassword}
                                            disabled={!isOpen}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                        />

                                        {/* Show/Hide Icon */}
                                        <button
                                            type="button"
                                            className="btn btn-sm p-0 border-0 bg-transparent"
                                            style={{ position: "absolute", top: "50%", right: "40px", transform: "translateY(-50%)" }}
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}></i>
                                        </button>

                                        {/* Edit Icon */}
                                        <button
                                            type="button"
                                            className="btn btn-sm p-0 border-0 bg-transparent"
                                            style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)" }}
                                            onClick={changepass}
                                        >
                                            <i className="fas fa-pencil-alt"></i>
                                        </button>
                                    </div>

                                    {isOpen && (
                                        <div className="mt-2">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control mb-2 bg-white"
                                                placeholder="Enter new password"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                            />

                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control mb-2 bg-white"
                                                placeholder="Confirm new password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />

                                            <button className="btn btn-success btn-sm" onClick={updatepass}>
                                                Change Password
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="text-center mt-4">
                                <button
                                    type="button"
                                    className="btn"
                                    style={{
                                        backgroundColor: '#1C4481',
                                        color: 'white',
                                        padding: '10px 30px',
                                        minWidth: '250px',
                                    }}
                                    onClick={() => updateProfiledetails()}
                                >
                                    UPDATE PROFILE
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
